import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Entries/DiagnosticEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'

const DiagnosticEntryOnGoingDirective = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  )
}

export default DiagnosticEntryOnGoingDirective
